import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AppShell from "../layouts/AppShell";
import { appModules } from "../components/global";
import Switch from "react-switch";
import { GET, POST, PUT, DELETE, loading, alert } from "../components/CustomComponent";

const AssetModal = ({ show, onHide, editData, onSave }) => {
  const [isActive, setIsActive] = useState(true);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
    <Modal.Header closeButton className="bg-light border-0">
      <Modal.Title className="fw-bold h5 mb-0">
        {editData ? "แก้ไขทรัพย์สิน" : "ลงทะเบียนทรัพย์สินใหม่"}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className="row g-3">
        <div className="col-md-6">
          <label className="form-label">รหัสทรัพย์สิน</label>
          <input type="text" className="form-control" defaultValue={editData?.code || ""} placeholder="เช่น IT-MAC-101" />
        </div>
        <div className="col-md-6">
          <label className="form-label">ชื่อทรัพย์สิน</label>
          <input type="text" className="form-control" defaultValue={editData?.name || ""} placeholder="ระบุชื่อทรัพย์สิน" />
        </div>
        <div className="col-md-6">
          <label className="form-label">ผู้ถือครอง</label>
          <input type="text" className="form-control" placeholder="ค้นหาพนักงาน..." />
        </div>
        <div className="col-md-6">
          <label className="form-label">สถานะ</label>
          <select className="form-select"><option>ใช้งานอยู่</option><option>ส่งซ่อม</option><option>ว่าง</option></select>
        </div>
         <div className="col-12">
          <label className="form-label mb-0 pointer" htmlFor="isActiveOvertime">เปิดใช้งาน (Active)</label><br/>
          <Switch checked={isActive} onChange={setIsActive} onColor="#0c75e6" height={24} width={48} id="isActiveOvertime" />
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer className="bg-light border-0">
      <button type="button" className="btn btn-secondary" onClick={onHide}>ยกเลิก</button>
      <button type="button" className="btn btn-primary" onClick={() => onSave({ isActive })}>บันทึกข้อมูล</button>
    </Modal.Footer>
  </Modal>
  );
};

export default function Assets() {
  const { title, description } = appModules["assets"];
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [data, setData] = useState([]);

  const summaryCards = [
    { label: "ทรัพย์สินทั้งหมด", value: "324", color: "#0c76e5" },
    { label: "ถูกยืม / จ่ายออกแล้ว", value: "280", color: "#48bb78" },
    { label: "ส่งซ่อม", value: "4", color: "#e53e3e" },
  ];

  const handleOpenModal = (data = null) => {
    setEditData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setShowModal(false);
  };

  const GetData = async () => {
    loading(true);
    let body = {};
    let result = await GET("v1/admin/assets", body);
    if (result?.status) {
      setData(result.data || []);
    }
    loading(false);
  };

  useEffect(() => {
    GetData();
  }, []);

  const CreateUpdate = async (formData) => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let uid = formData?.uid || editData?.uid;
      let body = { ...formData };

      let result = !uid
        ? await POST("v1/admin/assets", body)
        : await PUT("v1/admin/assets/" + uid, body);
        
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
        handleCloseModal();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const DeleteData = async (id) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบรายการนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let result = await DELETE("v1/admin/assets/" + id, null);
      if (result?.status) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
      }
      loading(false);
    }
  };

  return (
    <AppShell title={title} description={description}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div className="d-flex gap-2 filters-mobile-stack">
          <input type="text" className="form-control" placeholder="ค้นหาเลขครุภัณฑ์..." style={{ width: '250px', borderRadius: '12px' }} />
          <select className="form-select" style={{ width: '150px', borderRadius: '12px' }}>
            <option>หมวดหมู่ทั้งหมด</option>
            <option>IT</option>
            <option>Office</option>
          </select>
        </div>
        <button onClick={() => handleOpenModal()} className="btn btn-primary px-4">
          ลงทะเบียนทรัพย์สิน
        </button>
      </div>

      <div className="row g-3 mb-4">
        {summaryCards.map((item) => (
          <div key={item.label} className="col-12 col-md-4">
            <div
              className="h-100 rounded-4 p-4 d-flex flex-column justify-content-center"
              style={{
                background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
                border: "1px solid rgba(18, 125, 255, 0.10)",
                boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
              }}
            >
              <p className="small text-uppercase text-secondary mb-1">{item.label}</p>
              <h2 className="h2 mb-0 fw-bold" style={{ color: item.color }}>{item.value}</h2>
            </div>
          </div>
        ))}
      </div>

      <div
        className="rounded-4 p-3 bg-white"
        style={{
          border: "1px solid rgba(18, 125, 255, 0.10)",
          boxShadow: "0 4px 12px rgba(12, 118, 229, 0.04)",
        }}
      >
        <h5 className="mb-4 fw-semibold text-dark">ระบบจัดการทรัพย์สิน (Inventory)</h5>
        <div className="table-responsive table-mobile-cards">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-secondary fw-medium rounded-start">รหัสทรัพย์สิน</th>
                <th className="text-secondary fw-medium">ชื่อรายการ</th>
                <th className="text-secondary fw-medium">หมวดหมู่</th>
                <th className="text-secondary fw-medium">ผู้ถือครอง</th>
                <th className="text-secondary fw-medium rounded-end">สถานะ</th>
                <th className="text-secondary fw-medium rounded-end">จัดการ</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5].map((i) => (
                <tr key={i}>
                  <td data-label="รหัสทรัพย์สิน">IT-MAC-{String(100 + i).padStart(3, '0')}</td>
                  <td data-label="ชื่อรายการ"><div className="fw-medium">MacBook Pro 16" M3</div></td>
                  <td data-label="หมวดหมู่">อุปกรณ์ IT</td>
                  <td data-label="ผู้ถือครอง">คุณ พนักงาน {i}</td>
                  <td data-label="สถานะ"><span className="badge bg-success bg-opacity-10 text-success rounded-pill px-3 py-2">ใช้งานอยู่</span></td>
                  <td data-label="จัดการ"><button onClick={() => handleOpenModal({ code: `IT-MAC-${String(100 + i).padStart(3, '0')}`, name: `MacBook Pro 16" M3` })} className="btn btn-sm btn-outline-secondary rounded-3" title="แก้ไข"><i className="fa-solid fa-pen" /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <AssetModal show={showModal} onHide={handleCloseModal} editData={editData} onSave={CreateUpdate} />
    </AppShell>
  );
}